const config = window.__pt.settings.site;
const culture = window.__pt.cultureData;

export const getEmailValidatorService = async (params) => {
    const url = new URL(config.endPoints.validateEmailUrl);
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.json();
};